import { useRouter } from 'next/router'
import { assertExists } from './assert'

interface Options {
  assertExists?: boolean
}

/**
 * When you know the param comes from a path replacement in next, you don't want it as `string | string[]`
 */
export function usePathParam(param: string): string | null
export function usePathParam(param: string, options: { assertExists: true }): string
export function usePathParam(param: string, options: Options = { assertExists: false }): string | null {
  const { query } = useRouter()
  const res = query[param]?.toString()

  if (options.assertExists) {
    assertExists(res)
    return res
  } else {
    return res ?? null
  }
}
